<template>
  <v-col class="col-lg-4 col-md-6 col-sm-12" v-if="withActions || added">
    <v-card>
      <img :src="image" :alt="description" :height="height" class="v-card__img" />

      <v-card-title>
        <h6>{{ webDescription || description }}</h6>
        <v-tooltip bottom max-width="300" v-if="withActions">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">fa-info-circle</v-icon>
          </template>
          <div>
            <p>{{ details }}</p>
            <p v-if="warning">{{ warning }}</p>
          </div>
        </v-tooltip>
      </v-card-title>

      <v-card-subtitle>
        <div class="summary-wrap">
          <span class="price-text">{{ price | currency }}</span>
          <span v-if="!withActions">Quantity: {{ qty }}</span>
        </div>
      </v-card-subtitle>

      <v-card-actions v-if="withActions">
        <v-switch
          v-model="selected"
          @change="add"
          label="Add accessory"
        ></v-switch>

        <v-select
          label="Quantity"
          :items="range"
          v-model="qty"
          :disabled="!selected"
          @change="change"
        ></v-select>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    added: Boolean,
    quantity: Number,
    withActions: Boolean,
    image: String,
    partNumber: String,
    description: String,
    warning: String,
    webDescription: String,
    details: String,
    inventory: Number,
    colorsFlag: Boolean,
    sizesFlag: Boolean,
    retailPrice: Number,
    tier1Price: Number,
    tier2Price: Number,
    tier3Price: Number,
    tier4Price: Number,
    tier5Price: Number,
    small: Boolean
  },
  data() {
    const safeInventory = Number(this.inventory) || 0
    return {
      selected: this.added || false,
      qty: this.quantity || 0,
      part: this.partNumber ? this.partNumber.replace(/[-\s]/g, '').toUpperCase() : null,
      range: Array.from({ length: Math.max(1, safeInventory) + 1 }, (_, i) => i)
    }
  },
  computed: {
    ...mapState(['pricing']),
    ...mapGetters(['priceAccessory']),
    price() {
      return this[this.priceAccessory(this.pricing)]
    },
    height() {
      return this.small ? 140 : 200
    }
  },
  methods: {
    add(added) {
      if (added) {
        if (this.qty === 0) {
          this.qty = 1
        }
      } else {
        this.qty = 0
      }

      this.selected = added

      this.$store.commit('addAccessory', {
        part: this.part,
        added,
        quantity: this.qty
      })
    },
    change(quantity) {
      this.selected = quantity > 0
      this.$store.commit('addAccessory', {
        part: this.part,
        added: true,
        quantity
      })
    }
  }
}
</script>

<style scoped lang="scss">
.v-card__text {
  padding-bottom: 0;
}
.v-card__actions {
  padding: 0 16px;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (min-width: 580px) {
    flex-direction: row;
  }

  .v-select {
    @media screen and (min-width: 580px) {
      padding: 0 0 0 20px;
      width: 60px;
    }
  }
}
.v-input--switch {
  margin: 0;
}
.v-icon {
  position: absolute;
  right: 10px;
}
h6 {
  font-family: $body-font-family !important;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  margin-bottom: 12px;
  word-break: normal;
  max-width: 260px;
  min-height: 55px;

  @media screen and (min-width: 600px) {
    font-size: 18px;
  }

  span {
    display: block;
    font-size: 13px;
    font-weight: 300;
  }
}
.price-text {
  font-size: 18px;
  font-weight: 700;
}
.summary-wrap {
  display: flex;
  justify-content: space-between;
}
</style>
